import { type ReactNode } from 'react'
import AppIcon from '@/components/content/app/AppIcon'
import Link from '@/components/ui/Link'
import Pill from '@/components/ui/Pill'
import { checkAppBranding } from '@/lib/formatting'
import { PREFETCH } from '@/lib/prefetch'
import { cn, getBrandColors } from '@/lib/utils'
import type { BestCtaData } from '@/app/(app)/compare/[slug]/client-fetchers'

type BestCtaProps = BestCtaData & {
  className?: string
}

export default function BestCta({ apps, category, className }: BestCtaProps): ReactNode {
  if (!apps.length || !category.slug) return null

  const label = `Discover best ${category.nameLabelPlural?.toLowerCase() || 'apps'}`

  return (
    <Link
      href={`/best/${category.slug}`}
      prefetch={PREFETCH}
      aria-label={label}
      className={cn('group flex items-center gap-8', className)}
    >
      <div className="flex items-center">
        {apps.map((app, index) => {
          const { appIcon, appGlyph } = checkAppBranding(app)
          const { backgroundColor } = getBrandColors(app)

          return (
            <AppIcon
              key={app.id}
              icon={appIcon}
              glyph={appGlyph}
              name={app.name}
              background={backgroundColor}
              size={40}
              transition={false}
              className="-mr-4"
              style={{ zIndex: apps.length - index }}
            />
          )
        })}
      </div>
      <Pill as="span" style="primary" className="flex-1">
        {label}
      </Pill>
    </Link>
  )
}
